import React from "react";
import {
  FaArrowsAlt,
  FaGlobe,
  FaExchangeAlt,
  FaSyncAlt,
  FaNetworkWired,
  FaBolt,
  FaLayerGroup,
  FaRobot,
} from "react-icons/fa";

function TriangularArbitrage() {
  return (
    <>
      <div
        className="feature-style-one-area default-padding bg-gray blurry-shape-right-bottom"
        style={{
          backgroundImage:
            "url(https://validthemes.net/site-template/robok/assets/img/shape/3.png)",
        }}
      >
        <div className="container">
          <div className="row">
            <div className="col-lg-8">
              <div className="site-heading">
                <h4 className="sub-title">Our Features</h4>
                <h2 className="title split-text-right split-text-in-right split-lines">
                  Types of Crypto Arbitrage Bots We Build
                </h2>
              </div>
            </div>
          </div>
        </div>
        <div className="container">
          <div className="fade-up-anim">
            <div className="feature-style-one-items ">
              <div className="feature-style-one">
                <div className="content d-flex flex-column items-center">
                  <div className="icon-one pb-3">
                    <FaArrowsAlt size={42} />
                  </div>
                  <h4>Triangular Arbitrage Bots</h4>
                </div>
              </div>

              <div className="feature-style-one ">
                <div className="content d-flex flex-column items-center">
                  <div className="icon-one pb-3">
                    <FaGlobe size={42} />
                  </div>
                  <h4>Spatial Arbitrage Bots</h4>
                </div>
              </div>

              <div className="feature-style-one ">
                <div className="content d-flex flex-column items-center">
                  <div className="icon-one pb-3">
                    <FaExchangeAlt size={42} />
                  </div>
                  <h4>Inter-Exchange Arbitrage Bots</h4>
                </div>
              </div>
              <div className="feature-style-one ">
                <div className="content d-flex flex-column items-center">
                  <div className="icon-one pb-3">
                    <FaSyncAlt size={42} />
                  </div>
                  <h4>Intra-Exchange Arbitrage Bots</h4>
                </div>
              </div>
            </div>
            <div className="feature-style-one-items pt-5">
              <div className="feature-style-one">
                <div className="content d-flex flex-column items-center">
                  <div className="icon-one pb-3">
                    <FaNetworkWired size={42} />
                  </div>
                  <h4>Decentralized Arbitrage Bots</h4>
                </div>
              </div>

              <div className="feature-style-one ">
                <div className="content d-flex flex-column items-center">
                  <div className="icon-one pb-3">
                    <FaBolt size={42} />
                  </div>
                  <h4>MEV Flash Loan Arbitrage Bots</h4>
                </div>
              </div>

              <div className="feature-style-one ">
                <div className="content d-flex flex-column items-center">
                  <div className="icon-one pb-3">
                    <FaLayerGroup size={42} />
                  </div>
                  <h4>Sandwich Arbitrage Bots</h4>
                </div>
              </div>
              <div className="feature-style-one ">
                <div className="content d-flex flex-column items-center">
                  <div className="icon-one pb-3">
                    <FaRobot size={42} />
                  </div>
                  <h4>Crypto Arbitrage AI Bots</h4>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default TriangularArbitrage;
